<template>
  <employees-table-dialog
    :employees="employees"
    :tagCategories="tagCategories"
    :text="`${text} ${(employees && employees.length) || (variables ? 0 : '')}`"
    :title="title"
    :loading="$apollo.loading"
    @refresh="$apollo.queries.employees.refresh()"
    :disableButton="disableButton"
    :reason="reason"
    :versionId="versionId"
  />
</template>

<script>
import { mapGetters } from "vuex";
import EmployeesTableDialog from "@/components/employee/EmployeesTableDialog";

import TagCategoriesQuery from "@/graphql/TagCategories.gql";

import EmployeesWithAssignedTrainingQuery from "@/graphql/queries/EmployeesWithAssignedTraining.gql";
import EmployeesWithAssignedInstructionQuery from "@/graphql/queries/EmployeesWithAssignedInstruction.gql";
import RelevantEmployeesQuery from "@/graphql/queries/RelevantEmployees.gql";
import CombinedEmployeesQuery from "@/graphql/queries/CombinedEmployees.gql";
import EmployeesByTagIdsQuery from "@/graphql/queries/employee/EmployeesByTagIds.gql";

import {
  createTagCategories,
  createEmployeesSearch,
  getMissingParentTags,
} from "@/utils/common.js";

export default {
  props: {
    title: String,
    text: String,
    variables: Object,
    disableButton: Boolean,
    reason: String,
    versionId: String,
  },
  components: {
    EmployeesTableDialog,
  },
  computed: {
    ...mapGetters(["employeeHeaders"]),
  },
  apollo: {
    employees: {
      query() {
        if (this.variables && this.variables.combined) {
          return CombinedEmployeesQuery;
        }
        if (this.variables && this.variables.instructionId) {
          return EmployeesWithAssignedInstructionQuery;
        }
        if (this.variables && this.variables.trainingId) {
          return EmployeesWithAssignedTrainingQuery;
        }
        if (this.variables && this.variables.tagIdsGroups) {
          return RelevantEmployeesQuery;
        }
        if (this.variables && this.variables.tagIds) {
          return EmployeesByTagIdsQuery;
        }
      },
      variables() {
        return this.variables;
      },

      update(data) {
        return (
          data.employees &&
          data.employees.map((e) => {
            const missingParentTags = getMissingParentTags(e);
            const search = `${createEmployeesSearch(e, this.employeeHeaders)}${
              missingParentTags.length ? "|*" : ""
            }`;
            return {
              ...e,
              search,
              ...createTagCategories(this.tagCategories, e.tags),
              missingParentTags,
            };
          })
        );
      },
      skip() {
        return !this.tagCategories || !this.variables;
      },
    },

    tagCategories: {
      query: TagCategoriesQuery,
    },
  },
};
</script>
